(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"));
	else if(typeof define === 'function' && define.amd)
		define(["angular"], factory);
	else if(typeof exports === 'object')
		exports["PaymentsJS"] = factory(require("angular"));
	else
		root["PaymentsJS"] = factory(root["angular"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5526__) => {
return 